import { useFormFieldMeta } from './form-field-meta';

interface IFormLabelProps {
  noPadding?: boolean;
  label: string;
  name: string;
  hint?: string;
}

export const FormLabel = ({ noPadding, label, name, hint }: IFormLabelProps) => {
  const { hasError } = useFormFieldMeta(name);

  const fieldStateClasses = hasError ? 'text-red-600' : 'text-gray-900';

  return (
    <div className={`block ${noPadding ? '' : 'pb-1.5'}`}>
      <label htmlFor={name} className={`text-sm leading-6 ${fieldStateClasses}`}>
        {label}
      </label>
      {hint && <span className="ml-2 text-xs text-gray-500">({hint})</span>}
    </div>
  );
};
